/* Wires #store-credit-widget to StoreCreditCore and updates the UI.
   ES5-safe. Depends on store-credit-core.js being loaded first. */
(function () {
  'use strict';

  function money(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && format) {
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function collectLines(widget) {
    var lines = [];
    var rows = widget.querySelectorAll('[data-sc-accessory]');
    Array.prototype.forEach.call(rows, function (row) {
      var cb = row.querySelector('.addon-checkbox');
      lines.push({
        key: row,
        priceCents: parseInt(row.getAttribute('data-price'), 10) || 0,
        selected: !!(cb && cb.checked),
      });
    });
    // The chosen fulfillment option (ship / assembled pickup / in-box) is the
    // last line the credit applies to, mirroring how the function covers
    // shipping after accessories.
    var fsel = widget.querySelector('[data-sc-fulfill].sc-selected');
    if (fsel) {
      lines.push({
        key: fsel,
        priceCents: parseInt(fsel.getAttribute('data-price'), 10) || 0,
        selected: true,
      });
    }
    return lines;
  }

  function render(widget, bikePriceCents) {
    var core = window.StoreCreditCore;
    if (!core) return;
    var format = widget.getAttribute('data-money-format');
    var percent = parseFloat(widget.getAttribute('data-credit-percent')) || 10;
    var creditCents = core.creditFromBikePrice(bikePriceCents, percent);
    var result = core.computeCoverage(creditCents, collectLines(widget));

    // Reset every fulfillment option's price to plain; the selected one is
    // re-rendered (FREE / partial) by the main loop below.
    Array.prototype.forEach.call(widget.querySelectorAll('[data-sc-fulfill]'), function (opt) {
      var pe = opt.querySelector('.sc-price');
      if (!pe) return;
      var pre = opt.hasAttribute('data-estimate') ? '~' : '';
      pe.innerHTML = pre + money(parseInt(opt.getAttribute('data-price'), 10) || 0, format);
    });

    result.lines.forEach(function (l) {
      var row = l.key;
      var priceEl = row.querySelector('.sc-price');
      if (!priceEl) return;
      var origMoney = money(parseInt(row.getAttribute('data-price'), 10) || 0, format);
      var prefix = row.hasAttribute('data-estimate') ? '~' : '';
      if (!l.selected) {
        row.classList.remove('sc-selected');
        priceEl.innerHTML = prefix + origMoney;
      } else if (l.priceCents === 0) {
        row.classList.add('sc-selected');
        priceEl.innerHTML = prefix + origMoney;
      } else {
        row.classList.add('sc-selected');
        if (l.oweCents <= 0) {
          priceEl.innerHTML = '<span class="sc-strike">' + prefix + origMoney + '</span><span class="sc-badge sc-free">FREE</span>';
        } else if (l.coveredCents > 0) {
          priceEl.innerHTML = '<span class="sc-strike">' + prefix + origMoney + '</span>' +
            '<span class="sc-badge sc-partial">-' + money(l.coveredCents, format) + '</span> ' +
            '<span class="sc-pay">pay ' + money(l.oweCents, format) + '</span>';
        } else {
          priceEl.innerHTML = prefix + origMoney + ' <span class="sc-pay">credit used up</span>';
        }
      }
    });

    var set = function (sel, txt) { var el = widget.querySelector(sel); if (el) el.textContent = txt; };
    set('[data-sc-credit-total]', money(creditCents, format));
    set('[data-sc-remaining]', money(result.remainingCents, format) + ' left');
    set('[data-sc-selected-total]', money(result.selectedTotalCents, format));
    set('[data-sc-applied]', '-' + money(result.appliedCents, format));
    set('[data-sc-pay]', money(result.payCents, format));

    var bar = widget.querySelector('[data-sc-bar]');
    if (bar) bar.style.width = (creditCents > 0 ? Math.round((result.appliedCents / creditCents) * 100) : 0) + '%';
  }

  function init() {
    var widget = document.getElementById('store-credit-widget');
    if (!widget || !window.StoreCreditCore) return;
    var bikePrice = parseInt(widget.getAttribute('data-bike-price'), 10) || 0;

    // Each accessory tile toggles its (hidden) checkbox on click, then re-renders.
    // Clicking the tile directly is more reliable than relying on label activation.
    Array.prototype.forEach.call(widget.querySelectorAll('[data-sc-accessory]'), function (row) {
      row.addEventListener('click', function () {
        var cb = row.querySelector('.addon-checkbox');
        if (cb) cb.checked = !cb.checked;
        render(widget, bikePrice);
      });
    });

    // Fulfillment options behave like radio buttons: choosing one deselects the
    // rest. The assembled-pickup option carries a hidden checkbox with the
    // bike-assembly variant, so picking it adds that product to the cart.
    Array.prototype.forEach.call(widget.querySelectorAll('[data-sc-fulfill]'), function (opt) {
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(widget.querySelectorAll('[data-sc-fulfill]'), function (o) {
          o.classList.remove('sc-selected');
          var ocb = o.querySelector('.addon-checkbox');
          if (ocb) ocb.checked = false;
        });
        opt.classList.add('sc-selected');
        var cb = opt.querySelector('.addon-checkbox');
        if (cb) cb.checked = true;
        render(widget, bikePrice);
      });
    });

    window.StoreCredit = {
      recalc: function (cents) {
        if (typeof cents === 'number' && cents > 0) bikePrice = cents;
        render(widget, bikePrice);
      },
      refresh: function () { render(widget, bikePrice); },
    };

    render(widget, bikePrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
